<template>
	<div class="tab">
		<div>
			<div class="tab-btn">
				<div class="flex flex-align-center" v-if="0">
					<div class="ml-16 mr-30">
						<el-checkbox @change="checkeFun" v-model="allChecked"></el-checkbox>
					</div>
					<el-tooltip class="item" effect="dark" content="请选择活动" :disabled="selectionShopArr.length ? true : false" placement="top">
						<el-button @click="batchGroup">批量报团</el-button>
					</el-tooltip>
				</div>
				<div class="filter-item mr-12">
					<div class="label">团长</div>
					<div class="filter-box" style="height: auto">
						<commander-select
							:show-default="true"
							:show-close="false"
							:platformId="platformId"
							v-model="authorityId"
							:show-all="true"
							@change="getList(tabName, 1)"
						></commander-select>
					</div>
				</div>
				<updateTime ref="updateTime" :type="sync_type" @updateList="show()"></updateTime>
			</div>
			<multi-table
				v-loading="loading"
				element-loading-text="加载中"
				element-loading-background="rgba(255, 255, 255)"
				:isEmptyObj="isEmptyObj"
				:tabName="tabName"
				class="multiTable"
				ref="multiTable"
				:isShowHeader="false"
				:selectionChange="selectionChange"
				:columns="columns"
				@gePartnerList="gePartnerList"
				:list="list"
				:options="options"
				:total="total"
			>
				<empty :isSearch="isSearch" @btnClick="synchroFun" btnText="同步团长商品" :btnShow="!isSearch" ref="empty" slot="empty"></empty>
			</multi-table>
		</div>
		<synchro ref="synchro"></synchro>
		<tips ref="tips"></tips>
		<AuthAlertDialog ref="authAlertDialog"></AuthAlertDialog>
	</div>
</template>
<script>
import ColumnTypes from '@/utils/ColumnTypes';
import synchro from '@/views/common/dialog/synchro.vue';
import updateTime from '../../components/updateTime.vue';
import { activitySearch, activitySync } from '@/api/secondColonelManage';
import empty from '@/views/common/empty/index.vue';
import { checkAuthorize } from '@/api/shopManage';
import authMixin from '@/modules/auth/mixin';
import { getCommanderList } from '@/components/commanderSelect/index.js';
import commanderSelect from '@/components/commanderSelect/index.vue';
export default {
	name: 'tab',
	components: {
		updateTime,
		empty,
		synchro,
		Tips: () => import('@/modules/auth/tips.vue'),
		AuthAlertDialog: () => import('@/modules/auth/alert.vue'),
		commanderSelect,
	},
	props: ['platformId'],
	computed: {
		columns() {
			return [
				{
					key: 'shopDetails',
					type: ColumnTypes.channelCell,
					minWidth: '260',
				},
			];
		},
	},
	mixins: [authMixin],
	data() {
		return {
			options: { selectable: false },
			isEmptyObj: {
				isEmpty: false,
				isEmptyShop: true,
				searchEmpty: false,
				isAuth: true,
			},
			list: [],
			total: '0',
			filterArr: [],
			selectionShopArr: [],
			allChecked: false,
			params: {
				page_index: 1,
				page_size: 10,
				q: '',
			},
			tabName: '0',
			activity_count: '0',
			sync_type: '3',
			loading: false,
			isSearch: false,
			commanderList: [],
			authorityId: '',
			next_cursor: '',
		};
	},

	created() {
		const { q = '' } = this.$route.query;
		this.params.q = q;
	},
	methods: {
		async getList(tabName = '0', isSearch) {
			this.isSearch = this.authorityId ? 1 : Boolean(isSearch);
			this.loading = true;
			this.tabName = tabName;
			this.params.is_apply = tabName;
			this.params.authority_id = this.authorityId;
			if (this.params.page_index == 1) {
				this.params.next_cursor = '';
			} else {
				this.params.next_cursor = this.next_cursor || '';
			}
			const { code, data } = await activitySearch(this.params);
			if (code !== 0) return;
			this.activity_count = data.activity_count;
			this.list = data.list;
			this.next_cursor = data?.next_cursor;
			this.total = data.page.item_total + '';
			this.loading = false;
		},
		selectionChange(val) {
			this.selectionShopArr = val;
			if (!this.selectionShopArr.length) {
				this.allChecked = false;
			}
			if (this.selectionShopArr.length == this.filterArr.length) {
				this.allChecked = true;
			} else {
				this.allChecked = false;
			}
		},
		gePartnerList(val) {
			this.params.page_index = val.page_index;
			this.params.page_size = val.page_size;
			this.getList(this.tabName);
		},
		batchGroup() {
			if (!this.selectionShopArr.length) return;
			if (this.selectionShopArr.length > 10) {
				this.$message.warning('最多选择十条活动');
				return;
			}
			sessionStorage.setItem('selectionShopArr', JSON.stringify(this.selectionShopArr));
			let handLink = this.$router.resolve({
				path: '/channel/details',
				query: {
					desc: 'batch',
				},
			});
			window.open(handLink.href, '_blank');
		},

		//选中值
		checkeFun(e) {
			this.filterArr = [];
			this.filterArr = this.list.filter(item => item.other_status !== 2).filter(item => item.other_status !== 3);
			this.$refs.multiTable.$refs.baseTable.toggleSelection(this.filterArr, e);
		},
		refresh() {
			this.getList(this.tabName);
		},
		//筛选
		onSubmit(val) {
			console.log(11111111);
			Object.assign(this.params, val);
			this.getList(this.tabName, 1);
		},
		getSyncTime() {
			this.$refs.updateTime.getSyncTime('', this.platformId);
		},
		async show() {
			const { platformId, authorityId } = this;
			this.commanderList = await getCommanderList(true, platformId);
			if (!this.commanderList.length) {
				this.$message.error('暂无已授权团长，请联系管理员在“团队管理-团长授权”中进行团长授权');
				return;
			}
			this.callback(authorityId);
		},
		callback(val) {
			if (!val) {
				this.$message.error('请选择团长');
				return;
			}
			this.authorityId = val;
			this.updateList();
		},
		async updateList() {
			const { sync_type, authorityId: authority_id } = this;
			const { code } = await activitySync({ type: sync_type, authority_id });
			if (code !== 0) return;
			this.$message({
				iconClass: 'el-icon-info primary mr-10',
				message: '活动正在同步...',
			});
		},
		//同步
		// 保持不变
		async synchroFun() {
			const params = { platform_id: this.platformId };
			const data = await checkAuthorize(params);
			if (!data.bind_status) {
				this.checkAuthAdd(this.platformId);
			} else {
				this.updateList();
			}
		},
	},
};
</script>
<style lang="less" scoped>
/deep/ .el-table td.el-table__cell {
	border-top: 10px solid #fff;
	border-bottom: none;
}
/deep/ .el-table td.el-table__cell {
	background-color: #f9fbff;
	border-radius: 4px;
}
// /deep/ .el-table .cell {
//     padding-left: 0px;
// }
.tab-btn {
	display: flex;
	padding-bottom: 10px;
	align-items: center;
	justify-content: end;
}
.line {
	margin: 20px 0px;
	height: 1px;
	background: #eeeeee;
}
.filter-item {
	display: flex;
	align-items: center;
	.label {
		font-weight: bold;
		margin-right: 12px;
		color: #666;
		font-size: 14px;
	}
}
</style>
